import React from "react";

import { Props } from "./types";
import { Project } from "./project";
import styles from "./styles.scss";

function Projects({ projects, selectedProject, onSelectProject }: Props) {
  return (
    <ul className={styles.projects}>
      {[...projects]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((project) => (
          <li key={project.uuid}>
            <Project
              project={project}
              isSelected={selectedProject?.uuid === project.uuid}
              onSelect={() => onSelectProject(project)}
            />
          </li>
        ))}
    </ul>
  );
}

export { Projects };
